import { ExportReports } from '../interface/export-reports';

export const exportReportsFields: ExportReports[] = [
  {
    name: 'WD From',
    formControlName: 'wdfrom',
    type: 'date',
  },
  {
    name: 'WD To',
    formControlName: 'wdto',
    type: 'date',
  },
  {
    name: 'Orig From',
    formControlName: 'origfrom',
    type: 'date',
  },
  {
    name: 'Orig To',
    formControlName: 'origto',
    type: 'date',
  },
  {
    name: 'Appr From',
    formControlName: 'apprfrom',
    type: 'date',
  },
  {
    name: 'Appr To',
    formControlName: 'apprto',
    type: 'date',
  },
  {
    name: 'ProjNbr',
    formControlName: 'projnbr',
    type: 'text',
  },
  {
    name: 'SONbr',
    formControlName: 'sonbr',
    type: 'text',
  },
  {
    name: 'Vendor',
    formControlName: 'vendor',
    type: 'text',
  },
  {
    name: 'E Type',
    formControlName: 'etype',
    type: 'text',
  },
  {
    name: 'C Type',
    formControlName: 'ctype',
    type: 'text',
  },
];
